<template>
	<RouterView />
</template>

<script>
export default { name: 'Wizard' };
</script>
